import React from "react";
import { TransportTypeEnum } from "../../states/app-state"

export default function TransportTypeImage(props: { type: TransportTypeEnum,color?: 'white' | 'orange' }) { // color property added by Bearer Web Developer 
    if (props.type === TransportTypeEnum.riding) {
        if (props.color && props.color === "white") return <img src="/motorbike-white.svg" alt="motorcycle" width={50} height={50} /> // added by Bearer Web Developer
        return <img src="/motorcycle.png" alt="motorcycle" width={50} height={50} /> //  modified by Bearer Web Developer
    }
    else if (props.type === TransportTypeEnum.cycling) {
        if (props.color && props.color === "white") return <img src="/bike-white.svg" alt="motorcycle" width={50} height={50} /> // added by Bearer Web Developer
        return <img src="/pedal-bike.png" alt="pedal bike" width={50} height={50} /> //  modified by Bearer Web Developer
    }
    else if (props.type === TransportTypeEnum.walking) {
        if (props.color && props.color === "white") return <img src="/walk-white.svg" alt="motorcycle" width={50} height={50} /> // added by Bearer Web Developer
        return <img src="/directions-run.png" alt="directions run" width={50} height={50} /> //  modified by Bearer Web Developer
    }
    //  added by Bearer Web Developer start
    else if (props.type === TransportTypeEnum.driving) {
        if (props.color && props.color === "white") return <img src="/car-white.svg" alt="motorcycle" width={50} height={50} /> // added by Bearer Web Developer
        return <img src="/car.webp" alt="car" width={50} height={50} /> 
    }
    else if (props.type === TransportTypeEnum.drone) {
        if (props.color && props.color === "white") return <img src="/drone-white.svg" alt="motorcycle" width={50} height={50} /> // added by Bearer Web Developer
        return <img src="/drone.webp" alt="drone" width={50} height={50} /> 
    }
    else if (props.type === TransportTypeEnum.rover) {
        if (props.color && props.color === "white") return <img src="/rover-white.svg" alt="motorcycle" width={50} height={50} /> // added by Bearer Web Developer
        return <img src="/rover.webp" alt="rover" width={50} height={50} /> 
    }
    //  added by Bearer Web Developer end
    return <></>
}
